export const SvgThunderIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8331 2.4082L3.41094 11.3147C3.12026 11.6636 2.97492 11.838 2.9727 11.9853C2.97077 12.1133 3.02783 12.2351 3.12744 12.3156C3.24201 12.4082 3.46904 12.4082 3.92308 12.4082H9.99972L9.16639 19.0749L16.5885 10.1683C16.8792 9.81952 17.0245 9.64511 17.0267 9.49782C17.0287 9.36977 16.9716 9.24795 16.872 9.16746C16.7574 9.07487 16.5304 9.07487 16.0764 9.07487H9.99972L10.8331 2.4082Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const SvgZapThunderIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49935 15.3245H2.91602M5.41602 10.7412H1.66602M7.49935 6.15788H3.33268M14.166 3.24121L8.66899 10.9371C8.42568 11.2777 8.30403 11.448 8.3093 11.59C8.31388 11.7136 8.37316 11.8288 8.4711 11.9044C8.58358 11.9912 8.79288 11.9912 9.21147 11.9912H13.3327L12.4993 18.2412L17.9964 10.5454C18.2397 10.2047 18.3613 10.0344 18.3561 9.89244C18.3515 9.76881 18.2922 9.65362 18.1943 9.57803C18.0818 9.49121 17.8725 9.49121 17.4539 9.49121H13.3327L14.166 3.24121Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
